import React, { useEffect, useState } from 'react'
import { usePublication } from '../../../hooks/usePublication'
import { ButtonsRight } from '../../../interfaces/UI'
import { Fancybox } from '@fancyapps/ui';
import LeftMenuResources from '../LeftMenu/LeftMenuResources'
import parse from 'html-react-parser'
import { useParams } from 'react-router-dom';
import { typeLibro } from '../../../interfaces/Publication';

interface DataSheetProps {
    openButtons: ButtonsRight;
    setOpenButtons :  (buttosn : ButtonsRight) => void
  }

const DataSheet = ({openButtons, setOpenButtons} : DataSheetProps) => {
    let { idRevista, idLibro } = useParams();
    const typeLibroParam = idLibro ? "libros" : "revista"
    const typeLibro: string = idLibro ? "Libro" : "Revista";
    const {publication,  changePublication, path} = usePublication()
    const [openCitacion, setOpenCitacion] = useState<Boolean>(false)

    const [referenciaBibliografica, setReferenciaBibliografica] = useState<string>("")

    useEffect(() => {
      Fancybox.bind('[data-fancybox="video"]', {});
    }, [])


    const apiUrl = 'https://www.virtualpro.co/getRerenciaBibliografica.php'; // Reemplaza con la URL real de tu API

    const enviarDatos = async (estilo: string) => {


    //este codigo es tomado de postman

        setReferenciaBibliografica("...")
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "PHPSESSID=aa2cdf83ef999dc2defd385694730714");
        
        if(publication.urlVirtualpro){

          let id = "";
          const url = publication.urlVirtualpro.match(/(\d+)(?!.*\d)/);

          if (url) {
            id = url[0];
          }

            var formdata = new FormData();
            formdata.append("documento", id);
            formdata.append("estilo", estilo);
            
            var requestOptions : RequestInit = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
            };
            fetch(`https://api.virtualpro.co/api/articulo/referenciacion-bibliografica`, requestOptions)
            .then(response => response.json())
            .then(result => setReferenciaBibliografica(result.content))
            .catch(error => console.log('error', error));
        }
      
      
    };
    
    

    return (
        <div id="option-4" className={`aside__content ${openButtons.optFileDoc?"active":""}`}>
        <div className="aside__content-header">
          <h3>Ficha técnica</h3>
          <button
            className="btn btn-rounded btn-rounded-transparent btn-close"
            aria-label="Cerrar panel de Ficha Técnica"

            onClick = { ()=>{
                let tmpBtns : ButtonsRight = {...openButtons}
                tmpBtns.optFileDoc = false 
                setOpenButtons( tmpBtns ) 
              } }            
          >
            <span className="btn__icon"
              ><i className="icon icon-vpro-close"></i
            ></span>
          </button>
        </div>
        {/* aqui */}
        <div className={`aside__content-data main-sb ${openCitacion?"fadeon":""}`}> 
          <div className="data-sheet">
            <div className="data-sheet__header">
              <div className="data-sheet__header">
                {
                  (publication.autorImg && publication.autorVideo) && (
                    <a
                      href={publication.autorVideo.includes("https")
                        ? publication.autorVideo
                        : `https://www.youtube.com/watch?v=${publication.autorVideo}`}
                      className="data-sheet__header-link"
                      data-fancybox="video"
                    >
                      <img
                        src={
                          publication.autorImg.includes("https")
                            ? publication.autorImg
                            : `${path}images/${publication.autorImg}`
                        }
                        alt="video autor"
                      />
                    </a>
                  )
                }
              </div>
            </div>
            <div className="data-sheet__body">
              <ul className="data-list">
                <li className="data-list__item">
                  <div className="vp-label">
                    <div className="vp-label__name">{typeLibro}</div>
                  </div>
                  <div className="data-list__item-issbn">{typeLibroParam === 'libros' ? 'ISBN' : 'ISSN'}: {publication.issn}</div>
                  <div className="data-list__item-issbn" style={{display: publication?.doi ? 'block' : 'none'}}>DOI: {publication?.doi}</div>
                </li>
                <li className="data-list__item">
                  <div className="data-list__item-title">
                    Título
                  </div>
                  <div className="data-list__item-txt">
                    {publication.title}
                  </div>
                </li>
                {typeLibroParam === 'libros' && (<li className="data-list__item">
                  <div className="data-list__item-title">Autores</div>
                  <div className="data-list__item-txt">
                    <button type="button" className='author__link-ft' aria-label="Autores" onClick={() => {
                      setOpenButtons({...openButtons, optFileDoc: false, optAuthor: true})
                    }}>
                      {/* Alegre, Helena; Pitchers, Robert; Sægrov */}
                      { publication.authors?.map(author => author.lastname+", "+author.name).join("; ") }
                    </button>
                  </div>
                </li>)}
                {publication.editorName && (<li className="data-list__item">
                  <div className="data-list__item-title">Editor</div>
                  <div className="data-list__item-txt">
                    {publication.editorName}<br></br>
                    <a href={`${publication.editorURL}`} target="_blank">{publication.editorURL}</a>
                  </div>
                </li>)}
                {publication.language && (<li className="data-list__item">
                  <div className="data-list__item-title">Idioma</div>
                  <div className="data-list__item-txt">{publication.language}</div>
                </li>)}
                {publication.year && (<li className="data-list__item">
                  <div className="data-list__item-title">Año</div>
                  <div className="data-list__item-txt">{publication.year}</div>
                </li>)}
                {publication.category && (<li className="data-list__item">
                  <div className="data-list__item-title">Categoría</div>
                  <div className="data-list__item-txt">
                    {publication.category}
                  </div>
                </li>)}
                {publication.subcategory && (<li className="data-list__item">
                  <div className="data-list__item-title">Subcategoría</div>
                  <div className="data-list__item-txt">
                    {publication.subcategory}
                  </div>
                </li>)}
                {publication.applicationAreas && (<li className="data-list__item">
                  <div className="data-list__item-title">
                    Áreas de aplicación
                  </div>
                  <div className="data-list__item-txt">
                      {publication.applicationAreas}
                  </div>
                </li>)}
                <li className="data-list__item" style={{ display: publication.copyRightDetail ? 'block' : 'none'}}>
                  <div className="data-list__item-title">Copyright</div>
                  <div className="data-list__2col">
                    <div className="data-list__item-img">
                      <a href={publication.copyRightDetail?.url}><img src={publication.copyRightDetail?.img} alt="Licencia"/></a>
                    </div>
                    <div className="data-list__item-txt">
                      <div className="licence">
                        <a href={'https://www.virtualpro.co'}>{ publication.title }</a> by 
                          {
                            publication.authors?.map( (author, index) =>(
                                <span style={{marginRight: 4}} key={index}>
                                  {author.fullName}
                                  {publication.authors && publication.authors?.length > index + 1 ? ',' : ''}
                                </span>
                            ))
                          }
                        es licenciado bajo <a href={publication.copyRightDetail?.url}>{ publication.copyRightDetail?.abbreviation}</a>
                      </div>
                    </div>
                  </div>

                </li>
                {/* <li className="data-list__item">
                  <div className="data-list__item-title">Contiene:</div>
                  <div className="data-list__item-txt">

                        <LeftMenuResources
                          sections = {publication.sections}
                          showLengthResources={ false }
                          navigate={ false }
                          showAloneTypeResource={ true }
                        ></LeftMenuResources>

                  </div>
                </li> */}
              </ul>
            </div>
            <div className="data-sheet__footer"></div>
          </div>
        </div>
        <div className="aside__content-actions">
          <div className="sub-content">
              {/* aqui */}
            <div id="subc-1" className={`sub-content__content ${openCitacion?"xpand":""}`}>
              <div className="sub-content__actions">
                <button
                  type="button"
                  className="sub-button"
                  data-subc="subc-1"
                  aria-label="Cerrar panel de Citación Bibliográfica"
                  onClick = { ()=>{ setOpenCitacion(false) } }
                >
                  <span className="sub-button__icon"
                    ><i className="icon icon-vpro-chevron-down"></i
                  ></span>
                </button>
              </div>
              <div className="select-dd">

                <select
                  name="citacion"
                  id="citacion-select"
                  className="select-dd__select"

                //   onChange = { (e)=> enviarDatos() }

                  onChange={(e) => enviarDatos(e.target.value)}
                >
                    <option value="">Seleccione un estilo</option>
                    <option value="apa">APA 7a Edicion</option>
                    <option value="ieee">IEEE</option>
                    <option value="chicago-fullnote-bibliography">Chicago 17a Edicion</option>
                    <option value="vancouver">Vancouver</option>
                    <option value="modern-language-association">MLA 8th (Modern Language Association)</option>
                </select>

                <span className="select-dd__arrow"></span>
              </div>

              {/* <textarea
                name="Citacion"
                id="txtAreaCitacion"
                className="txt-area"
                cols={30}
                rows={10}
                // placeholder= {referenciaBibliografica}
              >
                  {referenciaBibliografica}
              </textarea> */}
              <p
                // name="Citacion"
                // id="txtAreaCitacion"
                className="txt-area"
                // cols={30}
                // rows={10}
                // placeholder= {referenciaBibliografica}
              >
                  {referenciaBibliografica?parse(referenciaBibliografica):null}
              </p>
              <a type="button" className="btn btn-alt-secondary btn--fw"
                href={`https://www.virtualpro.co/download/${publication.urlVirtualpro}.ris`}
                target = "_blank"
              >
                <span className="btn__label">Descargar RIS</span>
              </a>
            </div>
          </div>
          {/* //aqui */}
          { (publication.urlVirtualpro && typeLibroParam === 'libros') && (<button
            type="button"
            className={`btn btn-alt-primary btn-alt-primary--red btn--fw sub-button ${openCitacion?"selected":""}`}
            data-subc="subc-1"
            onClick = { () =>{ setOpenCitacion(!openCitacion) } }
          >
            <span className="btn__label">Citación Bibliográfica</span>
          </button>)}
          { (publication.urlVirtualpro && typeLibroParam === 'libros') && (<a
            type="button"
            className="btn btn-alt-secondary btn--fw"
            aria-label="Ver ficha técnica en Virtualpro"
            href= {`https://www.virtualpro.co/libros/${publication.urlVirtualpro}`}
            target = "_blank"
          >
            <span className="btn__label">Ver en Virtualpro</span>
          </a>)}
        </div>
      </div>

    )
}

export default DataSheet
